// extracted by mini-css-extract-plugin
export default {"dialog-window":"DialogBox_dialog-window__0tKhH","dialog-title":"DialogBox_dialog-title__+O2Xz","dialog-footer":"DialogBox_dialog-footer__qK4Ty"};